import { Pipe, PipeTransform } from '@angular/core';
import { ImgixService } from '../../services/imgix.service';

/*
 * Ensures a static asset path gets the right prefix
*/
@Pipe({ name: 'imgix' })
export class ImgixSrcPipe implements PipeTransform {
    constructor() {
    }
    transform(
        url: string, useSrcset?: boolean, imageQualityPercentage?: number, maxHeight?: number): string {
        return ImgixService.getImgixUrl(url, useSrcset, imageQualityPercentage, maxHeight);
    }
}
